const setUserObject = (isLoggedIn = false) => {
  if (typeof window === "undefined") {
    return;
  }
  if (!window.grandvision || !window.grandvision.user) {
    window.grandvision = {
      user: {}
    };
  }
  window.grandvision.user = { loggedIn: isLoggedIn };
};
export {
  setUserObject
};
//# sourceMappingURL=user.js.map
